/* eslint-disable no-console */
import { useAuth0 } from '@auth0/auth0-react';
import { currentProfileIdService, trackIdentity } from '@paddl/utils-js';
import React, { useEffect, useState, useContext, useMemo } from 'react';
import { node } from 'prop-types';
import axios from 'axios';
import * as Sentry from '@sentry/browser';
import pRetry, { AbortError } from 'p-retry';
import { PageLoadSpinner } from '@paddl/storybook';
const LoginContext = /*#__PURE__*/React.createContext({
  idToken: null,
  profileId: null
});
export const useLoginContext = () => useContext(LoginContext);
const run = id_token => async () => {
  var _response$data, _response$data2;
  console.log('GET /paddljobs-proxy/my-profile-id');
  const response = await axios.get("".concat(process.env.API_PREFIX_AT_WORK, "/paddljobs-proxy/my-profile-id"), {
    headers: {
      Authorization: "Bearer ".concat(id_token)
    }
  });

  // Abort retrying if the resource doesn't exist
  if (response.status === 404) {
    throw new AbortError(response.statusText);
  }
  if (response.status === 404) {
    throw new Error('Unauthorised');
  }
  console.log('DONE:: GET /paddljobs-proxy/my-profile-id', (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.profileId);
  return (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.profileId;
};
export const LoginGate = _ref => {
  let {
    children
  } = _ref;
  const {
    isLoading,
    isAuthenticated,
    error,
    user,
    loginWithRedirect,
    logout,
    getAccessTokenSilently
  } = useAuth0();
  const [isProfileIdLoading, setIsProfileIdLoading] = useState(true);
  const [profileId, setProfileId] = useState();
  const [idToken, setIdToken] = useState();
  const [isRedirecting, setIsRedirecting] = useState(false);
  console.log({
    isLoading,
    isAuthenticated,
    error,
    user
  });
  console.log(JSON.stringify({
    isLoading,
    isAuthenticated,
    error,
    user
  }));
  const contextValue = useMemo(() => {
    return {
      profileId,
      idToken
    };
  }, [profileId, idToken]);
  useEffect(() => {
    if (!isRedirecting && !isLoading && !isAuthenticated) {
      console.log('LoginGate: Unauthenticated, redirecting to login page.', {
        isLoading,
        isAuthenticated
      });
      setIsRedirecting(true);
      loginWithRedirect({
        appState: {
          returnTo: window.location
        }
      });
    }
  }, [isAuthenticated, isLoading, isRedirecting, loginWithRedirect]);
  useEffect(() => {
    if (isLoading || !isAuthenticated) return;
    const getProfileId = async () => {
      const {
        id_token
      } = await getAccessTokenSilently({
        detailedResponse: true,
        timeoutInSeconds: 15
      });
      setIdToken(id_token);
      const profile_id = await pRetry(run(id_token), {
        retries: 3
      });
      if (!profile_id) {
        currentProfileIdService.setCookie(null);
        console.error('Error getting profileId from auth0 token.');
        logout();
      }
      setProfileId(profile_id);
      currentProfileIdService.setCookie(profile_id);
      setIsProfileIdLoading(false);
      return profile_id;
    };
    getProfileId().then(profile_id => {
      Sentry.setUser({
        profileId: profile_id,
        email: user === null || user === void 0 ? void 0 : user.email,
        auth0Id: user === null || user === void 0 ? void 0 : user.sub
      });
      trackIdentity(profile_id);
    }).catch(e => {
      console.error(e);
      console.error('LoginGate: Error getting profileId from auth0 token.', {
        isLoading,
        isAuthenticated,
        user
      });
      Sentry.setUser({
        email: user === null || user === void 0 ? void 0 : user.email,
        auth0Id: user === null || user === void 0 ? void 0 : user.sub
      });
      Sentry.captureException(e);
      logout();
    });
  }, [getAccessTokenSilently, isLoading, isAuthenticated, logout, user]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(PageLoadSpinner, {
      progress: 50
    });
  }
  if (isAuthenticated && isProfileIdLoading) {
    return /*#__PURE__*/React.createElement(PageLoadSpinner, {
      progress: 100
    });
  }
  if (error) {
    console.log('LoginGate: Error authenticating user.');
    console.error(error);
    logout();
  }
  if (isAuthenticated) {
    // eslint-disable-next-line no-console
    console.log('LoginGate: Authenticated in as user:', user);
    return /*#__PURE__*/React.createElement(LoginContext.Provider, {
      value: contextValue
    }, children);
  }
  return /*#__PURE__*/React.createElement(PageLoadSpinner, {
    progress: 25
  });
};
LoginGate.propTypes = {
  children: node.isRequired
};